<div class="validation-container">
  <div class="body-header">
    <span class="casto-title large" [innerHTML]="'validation.carpentry.title' | translate"></span>
  </div>
  @if (!featureSettingsService.poseEnabled || !featureSettingsService.financementEnabled || !featureSettingsService.fidelityEnabled) {
    <div class="panel-content feature-disabled-panel d-flex flex-column gap-2" style="margin-bottom: 24px;">
      @if (!featureSettingsService.poseEnabled) {
        <p class="alert alert-warning m-0" [innerHTML]="'feature-settings.warning.pose' | translate"></p>
      }
      @if (!featureSettingsService.financementEnabled) {
        <p class="alert alert-warning m-0" [innerHTML]="'feature-settings.warning.financement' | translate"></p>
      }
      @if (!featureSettingsService.fidelityEnabled) {
        <p class="alert alert-warning m-0" [innerHTML]="'feature-settings.warning.fidelity' | translate"></p>
      }
    </div>
  }
  @if (!loading) {
    <div class="panel-content" id="prices">
      <div class="casto-card">
        <div [class]="currentInstallation.withInstallation ? 'content withInstallation' : 'content'">
          <table class="price-table">
            <tr class="top-row">
              <td>
                @if (currentInstallation.withInstallation) {
                  <span
                    class="casto-title"
                    [innerHTML]="
                      'validation.carpentry.with-installation'
                        | translate
                          : {
                              tva: this.currentInstallation.more2Years ? 10 : 20,
                            }
                    "></span>
                } @else {
                  <span class="casto-title" [innerHTML]="'validation.carpentry.without-installation' | translate"></span>
                }
              </td>
              <td>
              </td>
              <td>
              </td>
              <td>
                <span
                  class="blue"
                  [innerHTML]="
                    (featureSettingsService.financementEnabled
                      ? currentPricing.totalWithFunding
                      : currentPricing.totalWithoutFunding?.actualAmount)
                      | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                  ">
                </span>
              </td>
            </tr>

            @if (featureSettingsService.financementEnabled) {
              <tr class="funding">
                <td [innerHTML]="'validation.carpentry.funding-label' | translate"></td>
                <td></td>
                <td></td>
                <td>
                  <span
                    class="blue"
                    [innerHTML]="
                      'validation.carpentry.funding'
                        | translate
                          : {
                              mensuality: funding?.mensuality | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                              duration: funding?.duration,
                              interest: funding?.interest | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                            }
                    ">
                  </span>
                </td>
              </tr>
            }
            <!-- Ligne dédiée pour le sous-tableau -->
            <tr>
              <td class="inner-table-cell">
                <table class="inner-table">
                  @for (detail of currentPricing.detailConception | keyvalue; track detail.key) {
                    <tr>
                      <td [innerHTML]="'installation.carpentry.conception-details.productsPrice' | translate"></td>

                      <td>
                      </td>
                      <td>
                      </td>
                      <td class="price">
                        <span [innerHTML]="detail.value.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'">
                        </span>
                      </td>
                    </tr>
                  }
                </table>
              </td>
            </tr>

            @if (currentPricing.totalInstallation && currentInstallation.withInstallation) {
              <tr>
                <td>
                  <div class="horizontal-align-with-gap">
                    <span [innerHTML]="'installation.carpentry.with-installation.installation' | translate"></span>
                    <ng-casto-button
                      class="secondary"
                      (click)="openDetail()"
                      [label]="'installation.carpentry.with-installation.details' | translate"></ng-casto-button>
                  </div>
                </td>
                <td></td>
                <td></td>
                <td>
                  <span
                    class="blue"
                    [innerHTML]="
                      currentPricing.totalInstallation.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr'
                    ">
                  </span>
                </td>
              </tr>
            }
          </table>
        </div>
        @if (fidelityEnabled()) {
          <div class="footer">
            <div class="fidelity-container">
              @if (currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM) {
                <div class="c-casto-container" id="ccasto">
                  <img src="assets/img/c-castoprice.svg" alt="c-casto" class="c-casto" />
                  @if (fidelityLoading || !currentFidelity) {
                    <div class="loader-container">
                      <ng-casto-loader></ng-casto-loader>
                    </div>
                  } @else {
                    @if (currentFidelity?.freeCardCoupons.length > 0) {
                      <div class="rewards-container">
                        <div class="rewards-title">
                          @if (
                            currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE ||
                            currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE0
                          ) {
                            <span [innerHtml]="'validation.fidelity.ccasto-upgrade-title' | translate"></span>
                          } @else {
                            <span
                              [innerHTML]="
                                'validation.fidelity.rewards'
                                  | translate
                                    : {
                                        value: currentFidelity?.freeCardEarnedPoints,
                                        s: currentFidelity?.freeCardEarnedPoints > 1 ? 's' : '',
                                      }
                              "></span>
                          }
                        </div>
                        <div class="rewards-detail">
                          <div class="rewards-subtitle">
                            @if (
                              currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE ||
                              currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE0
                            ) {
                              <span
                                [innerHtml]="
                                  'validation.fidelity.ccasto-upgrade-subtitle'
                                    | translate: { coupons: currentFidelity?.freeCardCoupons | freeCardCouponRewards }
                                "></span>
                            } @else {
                              <span
                                [innerHtml]="
                                  'validation.fidelity.ccasto-rewards'
                                    | translate: { coupons: currentFidelity?.freeCardCoupons | freeCardCouponRewards }
                                "></span>
                            }
                          </div>
                          <div class="action">
                            @if (
                              currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE ||
                              currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE0
                            ) {
                              <ng-casto-button
                                class="primary"
                                [label]="'validation.fidelity.subscribe-free' | translate"
                                (click)="createFreeCard()"></ng-casto-button>
                            }
                          </div>
                        </div>
                      </div>
                    } @else {
                      <div class="no-rewards-container">
                        <span class="no-rewards" [innerHTML]="'validation.fidelity.no-rewards' | translate"></span>
                        <div class="action">
                          @if (
                            currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE ||
                            currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.AUCUNE0
                          ) {
                            <ng-casto-button
                              class="primary"
                              [label]="'validation.fidelity.subscribe-free' | translate"
                              (click)="createFreeCard()"></ng-casto-button>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              }

              <div class="c-casto-container" id="ccasto-max">
                <img src="assets/img/c-castomaxprice.svg" alt="c-castomax" class="c-casto" />
                @if (fidelityLoading || !currentFidelity) {
                  <div class="loader-container">
                    <ng-casto-loader></ng-casto-loader>
                  </div>
                } @else {
                  @if (premiumCardEarnedCoupons > 0) {
                    <div class="rewards-container">
                      <div class="rewards-title">
                        @if (currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM) {
                          <span
                            [innerHTML]="
                              'validation.fidelity.ccasto-max-upgrade-title'
                                | translate
                                  : {
                                      value: currentFidelity?.premiumCardEarnedPoints,
                                      s: premiumCardEarnedCoupons > 1 ? 's' : '',
                                    }
                            "></span>
                        } @else {
                          @if (isCardExpired) {
                            <span [innerHTML]="'validation.fidelity.ccasto-max-renew-title' | translate: {}"></span>
                          } @else {
                            <span
                              [innerHTML]="
                                'validation.fidelity.ccasto-max-rewards'
                                  | translate
                                    : {
                                        value: currentFidelity?.premiumCardEarnedPoints,
                                        count: premiumCardEarnedCoupons,
                                        s: premiumCardEarnedCoupons > 1 ? 's' : '',
                                      }
                              "></span>
                          }
                        }
                      </div>

                      <div class="rewards-detail">
                        @if (currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM) {
                          <div
                            class="rewards-subtitle"
                            [innerHTML]="
                              'validation.fidelity.ccasto-max-upgrade-subtitle'
                                | translate
                                  : {
                                      count: premiumCardEarnedCoupons,

                                      value: currentFidelity?.premiumCardCoupons[0]?.value,
                                      s: premiumCardEarnedCoupons > 1 ? 's' : '',
                                    }
                            "></div>
                        } @else if (isCardExpired) {
                          <div
                            class="rewards-subtitle"
                            [innerHTML]="
                              'validation.fidelity.ccasto-max-rewards'
                                | translate
                                  : {
                                      value: currentFidelity?.premiumCardEarnedPoints,
                                      count: premiumCardEarnedCoupons,
                                      s: premiumCardEarnedCoupons > 1 ? 's' : '',
                                    }
                            "></div>
                        }
                        <div class="action">
                          @if (currentCustomer?.fidelity?.cardIsPaidButNotActiveYet) {
                            <span [innerHTML]="'validation.fidelity.ccasto-max-waiting-activation' | translate"></span>
                            <ng-casto-button
                              class="primary"
                              [label]="'validation.fidelity.refresh' | translate"
                              (click)="refreshFidelity()"
                              [loading]="refreshLoading"></ng-casto-button>
                          } @else if (
                            isCardExpired && currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUM
                          ) {
                            <ng-casto-button
                              class="primary"
                              [label]="'validation.fidelity.renew' | translate"
                              (click)="updatePremiumCard()"></ng-casto-button>
                          } @else if (
                            currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM &&
                            currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUMWAITING
                          ) {
                            <ng-casto-button
                              class="primary"
                              [label]="'validation.fidelity.subscribe' | translate"
                              (click)="createPremiumCard()"></ng-casto-button>
                          } @else if (currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUMWAITING) {
                            <ng-casto-button
                              class="primary"
                              [label]="'validation.fidelity.pay' | translate"
                              (click)="getPaymentLink()"></ng-casto-button>
                          }
                        </div>
                      </div>
                    </div>
                  } @else {
                    <div class="no-rewards-container">
                      <span class="no-rewards" [innerHTML]="'validation.fidelity.no-rewards' | translate"></span>
                      <div class="action">
                        @if (currentCustomer?.fidelity?.cardIsPaidButNotActiveYet) {
                          <span [innerHTML]="'validation.fidelity.ccasto-max-waiting-activation' | translate"></span>
                          <ng-casto-button
                            class="primary"
                            [label]="'validation.fidelity.refresh' | translate"
                            (click)="refreshFidelity()"
                            [loading]="refreshLoading"></ng-casto-button>
                        } @else if (
                          isCardExpired && currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUM
                        ) {
                          <ng-casto-button
                            class="primary"
                            [label]="'validation.fidelity.renew' | translate"
                            (click)="updatePremiumCard()"></ng-casto-button>
                        } @else if (
                          currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUM &&
                          currentCustomer?.fidelity?.typeCard !== FidelityCardTypeEnum.PREMIUMWAITING
                        ) {
                          <ng-casto-button
                            class="primary"
                            [label]="'validation.fidelity.subscribe' | translate"
                            (click)="createPremiumCard()"></ng-casto-button>
                        } @else if (currentCustomer?.fidelity?.typeCard === FidelityCardTypeEnum.PREMIUMWAITING) {
                          <ng-casto-button
                            class="primary"
                            [label]="'validation.fidelity.pay' | translate"
                            (click)="getPaymentLink()"></ng-casto-button>
                        }
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    @if (!disableInstallation && featureSettingsService.poseEnabled) {
      @if (!currentWithInstallation) {
        <div class="panel-content" (click)="setWithInstallation(true)" id="installation">
          <div class="casto-card">
            <div class="header">
              <span
                class="casto-title"
                [innerHTML]="
                  'installation.carpentry.with-installation.title'
                    | translate
                      : {
                          amount: currentPricing?.delta?.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></span>
              <ng-casto-button
                class="primary"
                [label]="'generic.details' | translate"
                (click)="setWithInstallation(true)"></ng-casto-button>
            </div>
          </div>
        </div>
      } @else {
        <div class="panel-content" (click)="setWithInstallation(false)" id="installation">
          <div class="casto-card">
            <div class="header">
              <span
                class="casto-title"
                [innerHTML]="
                  'installation.carpentry.without-installation.title'
                    | translate
                      : {
                          amount: currentPricing?.delta.actualAmount | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr',
                        }
                "></span>
              <ng-casto-button
                class="primary"
                [label]="'generic.details' | translate"
                (click)="setWithInstallation(false)"></ng-casto-button>
            </div>
          </div>
        </div>
      }
    }
  } @else {
    <div class="loader-container">
      <ng-casto-loader></ng-casto-loader>
    </div>
  }
</div>
